import { cbfMap } from 'wizards/models/backup-to-restore-models';

export function isCBFBunch(id: string): boolean {
  return !!cbfMap[id];
}
